import { Component } from "react";
import { Link } from "react-router-dom";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ManualForms from "../../manual_forms";
import {
  addFasciaForm_action,
  updateFasciaForm_action,
  getFasciaDetails_action,
  getDefaultFasciaData_action,
  insertUpdateFacia_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/fascia_form_action/fascia_form_action";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import moment from "moment";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";

class FasciaForm extends Component {
  // Initialize Constructor
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      is_add: false,
      is_update: false,
      exhibitorName: "",
      hallNo: "",
      stallNo: "",
      stallType: "",
      area: "",
      sidesOpen: "",
      fasciaName: "",
      fasciaFormId: "",
      DeadlineDate: "",
      currentDate: moment().format("DD-MM-YYYY"),
      FasiaDate: "",
      StatusID: "",
      isStallDesignfill: false,
      StallTypeName: "",
      ActualDeadline: "",
      Is_View: false,
      RoleID: sessionStorage.getItem("RoleIDSS"),
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      fasciaNameErr: ''
    };
    this.handleSave = this.handleSave.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.getDetails = this.getDetails.bind(this);
    this.getDefaultData = this.getDefaultData.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.handleSave()
      }
      if (confirmationObj.action == 1) {
        this.handleUpdate()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    console.log("Fascia Props", this.props.location.state);

    this.setState(
      {
        is_update:
          this.props.location.state != null &&
            this.props.location.state != "" &&
            this.props.location.state.is_update != " "
            ? this.props.location.state.is_update
            : "",
        fasciaFormId:
          this.props.location.state != null &&
            this.props.location.state != "" &&
            this.props.location.state.fasciaFormId != " "
            ? this.props.location.state.fasciaFormId
            : "",
        DeadlineDate:
          this.props.location.state != null &&
            this.props.location.state != "" &&
            this.props.location.state.Deadline != ""
            ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
            : "",
        ActualDeadline:
          this.props.location.state != null &&
            this.props.location.state != "" &&
            this.props.location.state.ActualDeadline != ""
            ? moment(this.props.location.state.ActualDeadline).format("DD-MM-YYYY")
            : "",
        StatusID:
          this.props.location.state != null &&
            this.props.location.state != "" &&
            this.props.location.state.StatusID != ""
            ? this.props.location.state.StatusID
            : "",
        Is_View:
          this.props.location.state != null &&
            this.props.location.state != "" &&
            this.props.location.state.is_View != null
            ? this.props.location.state.is_View
            : false,
      },
      () => {
        this.getDetails();
        this.getDefaultData();
      }
    );

    console.log("this.props.location.state?.ManualFormsID",this.props.location.state?.ManualFormsID)
  }

  getDetails() {
    const { fasciaName, fasciaFormId } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getFasciaDetails_action(fasciaFormId)
      .then((data) => {
        if (data.error != 1) {
          if (data.data.length == 0) {
            this.setState({
              is_add: true,
              isLoading: false,
            });
          } else {
            this.setState({
              exhibitorName: data.data[0]["ExhibitorName"],
              hallNo: data.data[0]["HallNo"],
              stallNo: data.data[0]["StallNo"],
              stallType: data.data[0]["StallTypeID"],
              area: data.data[0]["Area"],
              sidesOpen: data.data[0]["OpenSides"],
              fasciaName: data.data[0]["FasciaName"],
              fasciaFormId:
                data.data[0]["FasciaFormID"] != null ? data.data[0]["FasciaFormID"] : "",
              isLoading: false,
            });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getDefaultData() {
    const { } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getDefaultFasciaData_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            isLoading: false,
            exhibitorName: data.data[0]["ExhibitorName"],
            hallNo: data.data[0]["HallNo"],
            stallNo: data.data[0]["StallNo"],
            stallType: data.data[0]["StallTypeID"],
            area: data.data[0]["StallArea"],
            sidesOpen: data.data[0]["OpenSides"],
            fasciaName: data.data[0]["FasciaName"],
            fasciaFormId: data.data[0]["FasciaFormID"] != null ? data.data[0]["FasciaFormID"] : "",
            FasiaDate: data.data[0]["FasiaDate"],
            isStallDesignfill: data.data[0]["isStallDesignfill"],
            StallTypeName: data.data[0]["StallTypeName"],
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // handleSave() {
  //     const { fasciaName } = this.state
  //     this.setState({ isLoading: true })
  //     this.props.addFasciaForm_action(fasciaName)
  //         .then(data => {
  //             if (data.error != 1) {
  //                 this.setState({ isLoading: false })
  //                 window.history.back()

  //             } else {
  //                 this.setState({ isLoading: false })
  //                 toastError(data.msg)
  //             }
  //         })
  //         .catch(err => { console.log(err) })
  // }

  handleSave() {
    const { fasciaName, fasciaFormId } = this.state;
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    if (fasciaName?.trim() != '' && fasciaName != null) {
      this.setState({ isLoading: true });
      this.props
        .insertUpdateFacia_action(fasciaName, fasciaFormId, ManualFormsID, ServiceID, VendorDetails)
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            setTimeout(() => {
              this.props.navigate('/manualForms')
            }, 2000);
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toastSuccess("Please enter mandatory field!")
      this.setState({ fasciaNameErr: 'Please enter fascia name' })
    }
  }

  handleUpdate() {
    const { fasciaFormId, fasciaName } = this.state;
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    if (fasciaName?.trim() != '' && fasciaName != null) {
      this.setState({ isLoading: true });
      this.props
        .insertUpdateFacia_action(fasciaName, fasciaFormId, ManualFormsID, ServiceID, VendorDetails)
        .then((data) => {
          if (data.error != 1) {
            toastSuccess("Fasia form updated successfully!");
            this.setState({ isLoading: false });
            setTimeout(() => {
              this.props.navigate("/manualForms");
            }, 2000);
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toastSuccess("Please enter mandatory field!")
      this.setState({ fasciaNameErr: 'Please enter fascia name' })
    }
  }

  handleCancel() {
    window.history.back();
  }

  render() {
    const {
      isLoading,
      is_add,
      is_update,
      exhibitorName,
      hallNo,
      stallNo,
      stallType,
      area,
      sidesOpen,
      fasciaName,
      DeadlineDate,
      currentDate,
      FasiaDate,
      StatusID,
      isStallDesignfill,
      ActualDeadline,
      Is_View,
      RoleID,
      isHideSection, isOpenConfirmationModal,fasciaNameErr
    } = this.state;
    const toInputUppercase = (e) => {
      e.target.value = ("" + e.target.value).toUpperCase();
    };

    const isDeadlinePassed = ActualDeadline && moment(ActualDeadline, "DD-MM-YYYY").isValid() && moment(currentDate, "DD-MM-YYYY").isAfter(moment(ActualDeadline, "DD-MM-YYYY"));

    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer></ToastContainer>
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className="page">
          <div className="page-main">
            <div className={!isHideSection ? "with-dr-container" : ""} style={{ marginTop: RoleID == 1 ? "0px" : "" }}>
              <div className=" width-dr-nav">
                {!isHideSection && (
                  <div className="row mt-4">
                    <ExhibitorTopMenu />
                  </div>
                )}
              </div>
              <div className="row mt-2 m-0">
                <div className="col-xl-12 mt-6">
                  <div className="card rounded-0 border p-0">
                    <div className="card-header p-2">
                      <h3 className="card-title">Fascia Form</h3>
                    </div>
                    {this.state.StallTypeName == "Shell Space" && !isStallDesignfill ? (
                      <div className="card-body p-2">
                        <div style={{ lineHeight: "25px", textAlign: "left" }}>
                          <p className="m-0">
                            <strong>Note:</strong>
                          </p>
                          <ul style={{ listStyleType: "disc" }}>
                            <li>
                              Exhibitors who had opted for shell scheme are requested to indicate
                              hereunder the name, which they require on the fascia. This will be
                              provided on Front Fascia of the stall with standard 75 mm high (3”)
                              ENGLISH ALPHABETS (Maximum 24 characters including spaces). Please use
                              block letters only. Logos may not be allowed on the fascia. If the
                              concerned exhibitor fails to submit this form within the deadline
                              date, the organizer will have no option but to incorporate on the
                              fascia the name of the company on which the booth is contracted.
                            </li>
                            <li>
                              For more details or any queries please contact: projects@india-itme.com & operations@india-itme.com.
                            </li>
                          </ul>
                        </div>

                        <div className="row">
                          <div className="col-xl-4">
                            <label htmlFor="validationCustom03">Exhibitor Name</label>
                            <input
                              type="text"
                              className="form-control"
                              // disabled={Is_View}
                              id="validationCustom03"
                              value={exhibitorName}
                              disabled
                            />
                          </div>
                          <div className="col-xl-4">
                            <label htmlFor="validationCustom03">Hall No</label>
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom03"
                              value={hallNo}
                              disabled
                            />
                          </div>
                          <div className="col-xl-4">
                            <label htmlFor="validationCustom03">Stall No</label>
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom03"
                              value={stallNo}
                              disabled
                            />
                          </div>
                          <div className="col-xl-4 mt-3">
                            <label htmlFor="validationCustom03">Stall Type</label>
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom03"
                              value={stallType}
                              disabled
                            />
                          </div>
                          <div className="col-xl-4 mt-3">
                            <label htmlFor="validationCustom03">Area</label>
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom03"
                              value={area}
                              disabled
                            />
                          </div>
                          <div className="col-xl-4 mt-3">
                            <label htmlFor="validationCustom03">Sides open</label>
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom03"
                              value={sidesOpen}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="row mt-4">
                          <h6 className="mt-2">
                            FASCIA NAME FOR SHELL SCHEME EXHIBITORS{" "}
                            <span className="text-danger">
                              {" "}
                              Last Date Of Submission - {ActualDeadline}
                            </span>
                          </h6>
                        </div>
                        <div className="row mt-4">
                          <div className="apper">
                            <h4>
                              <strong>
                                THE FOLLOWING NAME IS TO APPEAR ON THE FRONT FASCIA OF OUR STAND{" "}
                              </strong>
                            </h4>
                            <p className="text-danger mb-1 mt-2">
                              Fascia Name should not be greater than 26 characters
                            </p>
                            <textarea
                              type="textarea"
                              className="form-control text-left"
                              maxLength={26}
                              col=""
                              name=""
                              rows={2}
                              style={{ textAlign: "center" }}
                              placeholder={sessionStorage.getItem('ExhibitionName')}
                              value={fasciaName}
                              onInput={toInputUppercase}
                              onChange={(e) =>
                                !isDeadlinePassed && this.setState({ fasciaName: e.target.value, fasciaNameErr: '' })
                              }
                              disabled={isDeadlinePassed || StatusID == 2}
                            />
                            {
                              <span className="text-danger text-start text-left d-block">
                                {fasciaNameErr}
                              </span>
                            }

                            <div className="d-flex justify-content-end mt-0">
                              {is_add ? (
                                <button
                                  type="button"
                                  className="btn btn-aqua rounded-1 d-block mt-3 mb-3"
                                  style={{ marginRight: 10 }}
                                  disabled={isDeadlinePassed || isStallDesignfill}
                                  // onClick={() => this.handleSave()}
                                  onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 0 }, popArg: [] })}
                                >
                                  Submit
                                </button>
                              ) : (
                                <button
                                  className="btn btn-aqua rounded-1 d-block mt-3 mb-3"
                                  style={{ marginRight: 10 }}
                                  disabled={isDeadlinePassed || isStallDesignfill}
                                  // onClick={() => this.handleUpdate()}
                                  onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Update?`, buttonName: "Update", action: 1 }, popArg: [] })}
                                >
                                  Update
                                </button>
                              )}
                              <button
                                className="btn rounded-1 mt-3 mb-3 btn-gray"
                                onClick={() => this.handleCancel()}
                              >
                                Back
                              </button>
                            </div>
                            <div className="row">
                              {isDeadlinePassed && (
                                <span className="text-danger">
                                  THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="row mt-4" style={{ height: "100px", alignItems: "center" }}>
                          <h5 className="mt-2" style={{ textAlign: "center" }}>
                            {this.state.StallTypeName == "Shell Space" ? (
                              <span className="text-danger ">
                                Fascia Form is not available for Shell Space exhibitor when you fill
                                stall design form.
                              </span>
                            ) : (
                              <span className="text-danger ">
                                Fascia Form is not available for Bare Space exhibitor.
                              </span>
                            )}
                          </h5>
                        </div>
                        <div
                          className="row mt-4 mb-4 d-flex"
                          style={{ textAlign: "center", justifyContent: "center" }}
                        >
                          {!isHideSection && <div className="btn-group mt-4" style={{ width: "100px" }}>
                            <button
                              className="btn btn-gray"
                              onClick={() => this.handleCancel()}
                            >
                              Back
                            </button>
                          </div>}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    addFasciaForm_action,
    updateFasciaForm_action,
    getFasciaDetails_action,
    getDefaultFasciaData_action,
    insertUpdateFacia_action,
  })(FasciaForm)
);
